import {AppLocale} from './i18n.types';

const EXTERNAL_PATH_PATTERN = /^(https?:)?\/\//i;
export const SITE_PATH_LOCALES: AppLocale[] = ['zh-CN', 'zh-TW', 'en-US', 'ko-KR', 'ja-JP', 'fr-FR', 'es-ES'];

const splitUrlParts = (path: string) => {
    const hashIndex = path.indexOf('#');
    const queryIndex = path.indexOf('?');
    const endIndex = [hashIndex, queryIndex]
        .filter(index => index >= 0)
        .sort((left, right) => left - right)[0] ?? path.length;

    return {
        pathname: path.slice(0, endIndex) || '/',
        suffix: path.slice(endIndex)
    };
};

export const isSiteLocale = (value?: string | null): value is AppLocale => {
    return SITE_PATH_LOCALES.includes(value as AppLocale);
};

export const getSiteLocaleFromPathname = (pathname: string): AppLocale | null => {
    const [, firstSegment] = pathname.split('/');
    return isSiteLocale(firstSegment) ? firstSegment : null;
};

export const stripSiteLocaleFromPathname = (pathname: string): string => {
    const locale = getSiteLocaleFromPathname(pathname);
    if (!locale) {
        return pathname || '/';
    }

    const strippedPath = pathname.slice(locale.length + 1);
    return strippedPath || '/';
};

export const isPublicSitePath = (pathname: string): boolean => {
    return pathname === '/' || pathname.startsWith('/site')
        || pathname === '/login' || pathname === '/register' || pathname === '/assessment';
};

export const buildLocalizedSitePath = (path: string, locale: AppLocale): string => {
    if (!path || EXTERNAL_PATH_PATTERN.test(path) || path.startsWith('mailto:') || path.startsWith('tel:')) {
        return path;
    }

    const {pathname, suffix} = splitUrlParts(path);
    const normalizedPathname = stripSiteLocaleFromPathname(pathname);
    if (!isPublicSitePath(normalizedPathname)) {
        return path;
    }

    const localizedPathname = normalizedPathname === '/'
        ? `/${locale}`
        : `/${locale}${normalizedPathname}`;

    return `${localizedPathname}${suffix}`;
};
